import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { Form } from 'react-bootstrap';
import Pagination from 'website/components/stateful/Pagination';
import { Hyper } from '../../../../layout';
import Table from './Table';
import classes from './Websites.scss';

function makeFuzzy(str) {
  return str.replace(/[^0-9a-z]+/i, '').toLowerCase();
}

class Websites extends React.Component {
  static propTypes = {
    sites: PropTypes.array,
  };

  state = {
    page: 1,
    filter: '',
    perPage: 25,
  };

  handlePageChange = (page) => {
    this.setState({ page });
  };

  handleFilterChange = ({ target }) => {
    this.setState({ filter: target.value });
  };

  handleChangePerPage = ({ perPage, newPage }) => {
    this.setState({ perPage, page: newPage });
  };

  renderPagination = (sites) => {
    if (sites.length <= 25) return null;

    const { page, perPage } = this.state;
    const paginationProps = {
      currentPageNumber: page,
      totalPages: Math.ceil(sites.length / perPage),
      onClick: this.handlePageChange,
      onChangePerPage: this.handleChangePerPage,
      descriptor: 'websites',
      totalItems: sites.length,
      itemsPerPage: perPage,
    };

    return <Pagination {...paginationProps} />;
  };

  renderTable(sites) {
    const { page, filter, perPage } = this.state;

    let sitesToDisplay;
    const fuzzyFilter = makeFuzzy(filter);
    if (fuzzyFilter) {
      sitesToDisplay = sites.filter(({ name }) =>
        makeFuzzy(name).indexOf(fuzzyFilter) !== -1);
    } else {
      const start = (page - 1) * perPage;
      sitesToDisplay = sites.slice(start, start + perPage);
    }

    return (
      <div>
        <Form.Control
          placeholder="Filter websites"
          value={filter}
          onChange={this.handleFilterChange}
        />
        <Table sites={sitesToDisplay} />
        {fuzzyFilter ? null : this.renderPagination(sites)}
      </div>
    );
  }

  render() {
    const { sites } = this.props;

    return (
      <Hyper title="All Websites" websites={{ active: true }}>
        <Helmet title="All Websites" />

        <div className={classes.container}>
          {sites ? this.renderTable(sites) : 'Loading...'}
        </div>
      </Hyper>
    );
  }
}

export default Websites;
